import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.388 18.1H2C2 20 2.883 21 4.692 21H18.87c3.005 0 3.13-3.033 3.13-3.033h-2.034v-11.9c0-1.134-.877-2.067-1.941-2.067H4.692c-1.064 0-1.94.933-1.94 2.067v3.6c0 2.933 3.004 4.733 5.351 3.233.032-.033.063-.033.125-.067 3.725-2.5-.25-3.833-1.314-2.666-1.064 1.166-.25 4.6 4.507 5.1"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M2.751 6.067v3.6c0 2.576 2.318 4.278 4.472 3.638m0 0q.45-.132.88-.405c.032-.033.063-.033.126-.067 3.724-2.5-.25-3.833-1.315-2.666-.589.645-.603 1.985.309 3.138m0 0c.736.93 2.074 1.738 4.198 1.962"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M10.5 6.5H13"
    />
  </svg>
);
export const ComputerIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
